import React from 'react';
import { View } from 'react-native';
import Unicon from '@/components/General/Unicon';

const FileIcon = ({ filename, mimeType, size = 20, color = 'primary' }) => {
  const getIconName = () => {
    if (!filename && !mimeType) return 'file';
    
    const ext = filename ? filename.split('.').pop()?.toLowerCase() : '';
    const type = mimeType?.split('/')[0];
    
    // Images
    if (type === 'image' || ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'svg'].includes(ext)) {
      return 'file-image';
    }
    
    // Videos
    if (type === 'video' || ['mp4', 'mov', 'avi', 'webm', 'mkv'].includes(ext)) {
      return 'file-video';
    }
    
    // Audio
    if (type === 'audio' || ['mp3', 'wav', 'wma', 'm4a', 'aac', 'flac'].includes(ext)) {
      return 'file-music';
    }
    
    // PDF
    if (ext === 'pdf') {
      return 'file-pdf-box';
    }
    
    // Word documents
    if (['doc', 'docx', 'rtf'].includes(ext)) {
      return 'file-word';
    }
    
    // Excel spreadsheets
    if (['xls', 'xlsx', 'csv'].includes(ext)) {
      return 'file-excel';
    }
    
    // PowerPoint
    if (['ppt', 'pptx'].includes(ext)) {
      return 'file-powerpoint';
    }
    
    // Archives
    if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) {
      return 'folder-zip';
    }
    
    // Code files
    if (['js', 'jsx', 'ts', 'tsx', 'py', 'java', 'c', 'cpp', 'html', 'css', 'json', 'xml'].includes(ext)) {
      return 'code-braces';
    }
    
    // Text files
    if (['txt', 'md', 'log'].includes(ext)) {
      return 'file-document';
    }
    
    return 'file';
  };

  const iconName = getIconName();

  return (
    <View style={{ width: size, height: size, alignItems: 'center', justifyContent: 'center' }}>
      <Unicon name={iconName} size={size} colorVariant={color} library="material" />
    </View>
  );
};

export default FileIcon;
